/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import "react-toastify/dist/ReactToastify.css";
import { WealthyValidations, triggerToast } from "helpers";

const validateLeadFormData = (formData, token) => {
  const isPhoneNumberValid = WealthyValidations.validateFormField.phone(formData["phoneNumber"]);
  const isEmailValid = WealthyValidations.validateFormField.email(formData["email"]);
  const isNameValid = WealthyValidations.validateFormField.name(formData["firstName"]) && WealthyValidations.validateFormField.name(formData["lastName"]);

  const trimmedFirstName = formData.firstName.trim();
  const isFirstNameEmpty = !trimmedFirstName.length > 0;
  const isFirstNameTooLong = trimmedFirstName.length > 100 || trimmedFirstName.length < 0 ? true : false;

  const trimmedLastName = formData.lastName.trim();
  const isLastNameEmpty = !trimmedLastName.length > 0;
  const isLastNameTooLong = trimmedLastName.length > 100 || trimmedLastName.length < 0 ? true : false;

  if (!isPhoneNumberValid) {
    triggerToast("Please enter a valid phone number");
    return false;
  }
  if (isFirstNameEmpty || isLastNameEmpty) {
    triggerToast("Name can not be empty");
    return false;
  }
  if (isFirstNameTooLong || isLastNameTooLong) {
    triggerToast("Name can not exceed 100 characters");
    return false;
  }
  if (!isNameValid) {
    triggerToast("Name can only contain letters");
    return false;
  }
  if (!isEmailValid) {
    triggerToast("Please enter a valid email");
    return false;
  }
  if (!token) {
    triggerToast("Captcha Failed! Please refresh the page and try again");
    return false;
  }

  return true;
};

export default validateLeadFormData;
